import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import reusedCodeMixin from "@/mixins/reusedCode.mixin";
import navigation from "@/static/values/navigation";
import AnimateOnScroll from "@/library/animateonscroll";

createApp(App)
    .use(store)
    .use(router)
    .mixin(reusedCodeMixin)
    .directive('animateonscroll', AnimateOnScroll)
    .mixin(navigation)
    .mount('#app')
